globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.LocalManagement = appCustomerSpace.Controllers.LocalManagement || {};

appCustomerSpace.Controllers.LocalManagement.ServicesController = (function(superClass) {

  utils.extend(ServicesController, superClass);

  function ServicesController() {
    return ServicesController.__super__.constructor.apply(this, arguments);
  }

  $.extend(ServicesController.prototype, {
    init: function(){
      this.initEvents();
      this.showPendingGenerationLoaders();

      return ServicesController.__super__.init.apply(this, arguments);
    },
    initEvents: function(){
      $('body.service-items').on('submit', '.delete-service-item-form', function(e){
        e.preventDefault();
        var form = $(this);
        var url = form.attr('action');

        $.ajax({
          type: "PATCH",
          url: url,
          data: new FormData(form[0]),
          processData: false,
          contentType: false,
          success: function(data) {
            if (data.response == 1) {
              var $thumbnail = $(data.views.thumbnail),
              id = $thumbnail.data('activity-id'),
              $currentThumbnail = $('.business-activity-service-items[data-activity-id='+id+']');

              $currentThumbnail.replaceWith($thumbnail);
              appCustomerSpace.LimitlessPlugins.initPlugins($('.business-activity-service-items[data-activity-id='+id+']'));
            } else {
              alert("Une erreur est survenue");
            }
          }
        });
      })
    },
    showPendingGenerationLoaders: function(){
      var $pendingCells = $('.service-item-description-cell[data-pending-ai-request="true"]');
      $pendingCells.each(function(){
        appCustomerSpace.Loader().start({ $container: $(this), options: {text: false, icon_size: '1x', style: { backdrop: { background: "#ffffff", justifyContent: "left" }, spinner: {marginBottom: "0px", marginLeft: "20px"}}} });
      });
      if ($pendingCells.length > 0) {
        setTimeout(function(){ window.location.reload(); }, 5000);
      }
    }
  });

  return ServicesController;

})(appCustomerSpace.Controllers.LocalManagement.MainController);
